import { render, staticRenderFns } from "./ProductGalleries.vue?vue&type=template&id=b41a4f46&scoped=true"
import script from "./ProductGalleries.vue?vue&type=script&lang=js"
export * from "./ProductGalleries.vue?vue&type=script&lang=js"
import style0 from "./ProductGalleries.vue?vue&type=style&index=0&id=b41a4f46&prod&scoped=true&lang=css"
import style1 from "./ProductGalleries.vue?vue&type=style&index=1&id=b41a4f46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41a4f46",
  null
  
)

export default component.exports